import React from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  SimpleGrid,
  VStack,
  Icon,
  Image,
  useColorModeValue,
} from "@chakra-ui/react";
import { FaBuilding, FaUsers, FaGlobe, FaRocket } from "react-icons/fa";

const IdealFor = ({ product }) => {
  const textColor = useColorModeValue("gray.600", "gray.300");
  const headingColor = useColorModeValue("blue.800", "blue.200");

  if (!product || !product.idealFor) return null;

  const getIcon = (index) => {
    const icons = [FaBuilding, FaUsers, FaGlobe, FaRocket];
    return icons[index % icons.length];
  };

  return (
    <Box py={16} borderRadius="xl">
      <Container maxW="6xl">
        <VStack spacing={8} align="start">
          <VStack spacing={4} align="start" w="full">
            <Heading
              as="h2"
              size="xl"
              color={headingColor}
              textAlign="center"
              w="full"
            >
              Ideal For
            </Heading>
            <Text
              fontSize="lg"
              color={textColor}
              textAlign="center"
              w="full"
              maxW="3xl"
              mx="auto"
            >
              {product.title} is perfectly suited for these use cases and organizations.
            </Text>
          </VStack>

          <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6} w="full">
            {product.idealFor.map((useCase, index) => (
              <Box
                key={index}
                p={6}
                bg="white"
                borderRadius="lg"
                border="1px"
                borderColor="blue.100"
                _hover={{
                  transform: "translateY(-4px)",
                  borderColor: "blue.300",
                }}
                transition="all 0.3s"
              >
                <VStack align="center" spacing={4} textAlign="center">
                  {/* Show custom icon if available, otherwise use default icon */}
                  {useCase.icon ? (
                    <Image
                      src={useCase.icon}
                      alt={useCase.title}
                      boxSize={8}
                      objectFit="contain"
                    />
                  ) : (
                    <Icon
                      as={getIcon(index)}
                      color="#000B8C"
                      boxSize={8}
                    />
                  )}
                  <VStack spacing={2}>
                    <Text
                      fontSize="md"
                      fontWeight="semibold"
                      color={headingColor}
                      lineHeight="tall"
                    >
                      {typeof useCase === 'string' ? useCase : useCase.title}
                    </Text>
                    {/* Show description if available */}
                    {useCase.description && (
                      <Text
                        fontSize="sm"
                        color={textColor}
                        lineHeight="tall"
                      >
                        {useCase.description}
                      </Text>
                    )}
                  </VStack>
                </VStack>
              </Box>
            ))}
          </SimpleGrid>
        </VStack>
      </Container>
    </Box>
  );
};

export default IdealFor;
